export enum CreativeStatusEnum {
  ACTIVE = 'active',
  CREATING = 'creating',
  UPLOADING = 'uploading',
  ERROR = 'error',
  EXPIRED = 'expired',
}

export enum CampaignCreativeStatusEnum {
  CREATIVE_STATUS_UNSPECIFIED = 'CREATIVE_STATUS_UNSPECIFIED',
  CREATIVE_STATUS_ACCEPTED = 'CREATIVE_STATUS_ACCEPTED',
  CREATIVE_STATUS_ACTIVE = 'CREATIVE_STATUS_ACTIVE',
  CREATIVE_STATUS_CANCELLED = 'CREATIVE_STATUS_CANCELLED',
  CREATIVE_STATUS_DELETED = 'CREATIVE_STATUS_DELETED',
  CREATIVE_STATUS_FAILED = 'CREATIVE_STATUS_FAILED',
  CREATIVE_STATUS_SUCCEEDED = 'CREATIVE_STATUS_SUCCEEDED',
  CREATIVE_STATUS_SUSPENDED = 'CREATIVE_STATUS_SUSPENDED',
  CREATIVE_STATUS_VERIFIED = 'CREATIVE_STATUS_VERIFIED',
  CREATIVE_STATUS_CREATING = 'CREATIVE_STATUS_CREATING',
  CREATIVE_STATUS_DELETING = 'CREATIVE_STATUS_DELETING',
  CREATIVE_STATUS_PENDING = 'CREATIVE_STATUS_PENDING',
  CREATIVE_STATUS_REPAIRING = 'CREATIVE_STATUS_REPAIRING',
  CREATIVE_STATUS_RUNNING = 'CREATIVE_STATUS_RUNNING',
  CREATIVE_STATUS_SUSPENDING = 'CREATIVE_STATUS_SUSPENDING',
  CREATIVE_STATUS_APPROVED = 'CREATIVE_STATUS_APPROVED',
  CREATIVE_STATUS_DISABLED = 'CREATIVE_STATUS_DISABLED',
  CREATIVE_STATUS_STORED = 'CREATIVE_STATUS_STORED',
  CREATIVE_STATUS_INITIALIZING = 'CREATIVE_STATUS_INITIALIZING',
  CREATIVE_STATUS_PROCESSING = 'CREATIVE_STATUS_PROCESSING',
  CREATIVE_STATUS_STORING = 'CREATIVE_STATUS_STORING',
  CREATIVE_STATUS_TRANSCODING = 'CREATIVE_STATUS_TRANSCODING',
  CREATIVE_STATUS_UPLOADING = 'CREATIVE_STATUS_UPLOADING',
  CREATIVE_STATUS_VASTING = 'CREATIVE_STATUS_VASTING',
  CREATIVE_STATUS_APPROVE = 'CREATIVE_STATUS_APPROVE',
  CREATIVE_STATUS_ERROR = 'CREATIVE_STATUS_ERROR',
  CREATIVE_STATUS_PROCESS = 'CREATIVE_STATUS_PROCESS',
  CREATIVE_STATUS_REVIEW = 'CREATIVE_STATUS_REVIEW',
  CREATIVE_STATUS_ARCHIVED = 'CREATIVE_STATUS_ARCHIVED',
  CREATIVE_STATUS_EXPIRED = 'CREATIVE_STATUS_EXPIRED',
  CREATIVE_STATUS_PURGED = 'CREATIVE_STATUS_PURGED',
  CREATIVE_STATUS_UNARCHIVING = 'CREATIVE_STATUS_UNARCHIVING',
}

export enum CampaignCreativeTypeEnum {
  CREATIVE_TYPE_UNSPECIFIED = 'CREATIVE_TYPE_UNSPECIFIED',
  CREATIVE_TYPE_BANNER = 'CREATIVE_TYPE_BANNER',
  CREATIVE_TYPE_NATIVE_BANNER = 'CREATIVE_TYPE_NATIVE_BANNER',
  CREATIVE_TYPE_NATIVE_VIDEO = 'CREATIVE_TYPE_NATIVE_VIDEO',
  CREATIVE_TYPE_HTML5 = 'CREATIVE_TYPE_HTML5',
  CREATIVE_TYPE_VAST_TAG = 'CREATIVE_TYPE_VAST_TAG',
  CREATIVE_TYPE_AD_TAG = 'CREATIVE_TYPE_AD_TAG',
  CREATIVE_TYPE_OTT = 'CREATIVE_TYPE_OTT',
  CREATIVE_TYPE_AUDIO = 'CREATIVE_TYPE_AUDIO',
  CREATIVE_TYPE_VIDEO = 'CREATIVE_TYPE_VIDEO',
  CREATIVE_TYPE_MAIL_PIECE = 'CREATIVE_TYPE_MAIL_PIECE',
}

export enum CreativeTargetTypeEnum {
  AUDIENCE_TYPE_DEVICE = 'AUDIENCE_TYPE_DEVICE',
  AUDIENCE_TYPE_DC = 'AUDIENCE_TYPE_DC',
  AUDIENCE_TYPE_B2C = 'AUDIENCE_TYPE_B2C',
  AUDIENCE_TYPE_IP_FOR_ETHASH = 'AUDIENCE_TYPE_IP_FOR_ETHASH',
}

export enum CreativeName {
  VIDEO = 'video_creative',
  BANNER = 'banner_creative',
}

export enum CampaignOrderlineCreativeTypeEnum {
  BANNER = 'Banner',
  VIDEO = 'Video',
}

export enum CreativeTypeEnum {
  BANNER = 'banner',
  VIDEO = 'video',
}

export enum AudienceStatusEnum {
  ACTIVE = 'Active',
  PENDING = 'Pending',
  ERROR = 'Error',
  IN_USE = 'In Use',
}

export enum OrderlineStatusEnum {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  IN_REVIEW = 'In Review',
  ACTIVE = 'Active',
  PAUSED = 'Paused',
  COMPLETED = 'Completed',
}

export enum OrderlineActionsEnum {
  RENAME = 'Rename',
  RESUME = 'Resume ad',
  EDIT_DATES = 'Edit Dates',
  PAUSE = 'Pause',
  CONTACT_SUPPORT = 'Contact Support',
  DOWNLOAD_PDF = 'Download PDF',
}

export enum CampaignStatusEnum {
  CREATING = 'Creating',
  ERROR = 'Error',
  IN_REVIEW = 'In Review',
  PAYMENT_FAILED = 'Payment Failed',
  ACTIVE = 'Active',
  COMPLETED = 'Completed',
}

export enum CampaignEltoroStatusEnum {
  CREATING = 'Creating',
  ERROR = 'Error',
  IN_REVIEW = 'In Review',
}

export enum CampaignStep {
  NAME = 1,
  AUDIENCE,
  CREATIVE,
  CHECKOUT,
  DONE,
}

export const campaignStepName = {
  1: 'name',
  2: 'setup',
  3: 'creatives',
  4: 'calculate',
  5: 'done',
};

export enum ProspectNameTypeEnums {
  SELL_YOUR_LISTING_FASTER = 'Sell Your Listing Faster',
  TALK_TO_YOUR_SPHERE = 'Talk To Your Sphere',
  GROW_YOUR_SPHERE = 'Grow Your Sphere',
  LIKELY_SELLERS = 'Likely Sellers',
  VIRTUAL_JUST_LISTED_JUST_SOLD = 'Virtual Just Listed/Just Sold',
  DIGITAL_FARMING = 'Digital Farming',
  SYNC = 'Synced',
}

export enum NotificationStatusEnum {
  SUCCESS = 'Success',
  INFORMATION = 'Information',
  ERROR = 'Error',
  WARNING = 'Warning',
  GAINED = 'Gained',
  REMINDER = 'Reminder',
  SUBMITTED = 'Submitted',
  CONTACTS = 'Contacts',
}

export enum NotificationSettingType {
  ACCOUNT = 'Account',
  CONTACTS = 'Contacts',
  CAMPAIGN = 'Campaign',
  ASSISTANT_ALERTS = 'Assistant Alerts',
}

export enum UserDeviceEnum {
  WEB = 'web',
  ANDROID = 'android',
  IOS = 'ios',
}

export enum GuideEnum {
  CONTACTS = 'CONTACTS',
  RECOMENDATIONS = 'RECOMENDATIONS',
}

export enum RecommendationContactEnum {
  SELLER = 'SELLER',
  BUYER = 'BUYER',
}

export enum RecommendationTypeEnum {
  AGENT = 'Agent type',
  LISTING = 'Listing',
  SOLD_LISTING = 'Sold Listing',
}

export enum RecommendationListingEnum {
  PROMOTION = 'Promote Your Listing',
  ALERT_NEIGHBORS = 'Alert Neighbors',
  ALERT_ABOUT_SOLD = 'Alert Neighbors about Sold Listing',
}

export enum UserStatus {
  PENDING = 'Pending',
  EXPIRED = 'Expired',
  REGISTERED = 'Registered',
  CONFIRMED = 'Confirmed',
  COMPLETE = 'Complete',
  ACTIVE = 'Active',
  ON_HOLD = 'On Hold',
  DEACTIVATED = 'Deactivated',
  SUSPENDED = 'Suspended',
  PAYMENT_FAIL = 'Payment Fail',
  CLOSED = 'Closed',
}

export enum UserStatusLoginDenied {
  SUSPENDED = UserStatus.SUSPENDED,
  CLOSED = UserStatus.CLOSED,
}

export enum SubscriptionName {
  basic = 'beewo-subscription-basic',
  premium = 'beewo-subscription-premium',
}

export enum GoalSectionTitles {
  CONQUEST_LEADS = 'Conquest Leads',
  RETENTION = 'Retention',
  PROMOTE_LISTING = 'Promote Listing',
  BRANDING_AWARENESS = 'Branding Awareness',
}

export enum Tabs {
  ORDERLINES = 'orderlines',
  CAMPAIGNS = 'campaigns',
}

export enum AIRespondStatus {
  GREETING = 'greeting',
  COMPLETED = 'completed',
  GENERATION_FAILED = 'failed',
  CONVERSION_FAILED = 'conversion_failed',
  APPROVED = 'approved',
}

export enum IntentStatus {
  ACTIONABLE = 'actionable',
  OUT_OF_SCOPE = 'out_of_scope',
  NON_ACTIONABLE_RELATED = 'non_actionable_related',
  IRRELEVANT = 'irrelevant',
}

export enum GenerationTypeEnum {
  GENERATED = 'generated',
  INITIAL = 'initial',
  SELECTED = 'selected',
  AUTOMATIC = 'automatic',
}
